export const map = {
    components: {
        popinLogin: require('components/popin-login/popin-login.desktop'),
        masterSlider: require('components/master-slider/master-slider.desktop'),
        advancedSlider: require('components/advanced-slider/advanced-slider.desktop'),
        discoverNews: require('components/discover-news/discover-news.desktop'),
        masterVideo: require('components/master-video/master-video.desktop'),
        header: require('components/header/header.desktop'),
        menu: require('components/menu/menu.desktop'),
        toggleFavorite: require('components/toggle-favorite/toggle-favorite'),
        buttonFloat: require('components/button-float/button-float'),
        productInnovationPopin: require('components/product-innovation-popin/product-innovation-popin'),
        videoCard: require('components/video-card/video-card.desktop'),
        popinVideo: require('components/popin-video/popin-video.desktop'),
        sliderVideo: require('components/slider-video/slider-video.desktop'),

    },
    pages: {
        myaccount: { index: require('pages/my-account/my-account-index.desktop') },
        resetpassword: { index: require('pages/reset-password/reset-password-index.desktop') },
        register: { index: require('pages/register/register-index.desktop') },
        homepage: {
            index: require('pages/homepage/homepage-index.desktop')
        },
        homepage2025: {
            index: require('pages/homepage-2025/homepage-2025-index')
        },
        legals: {
            index: require('pages/legals/legals-index.desktop')
        },
        about: {
            list: require('pages/about/list/about-list.desktop'),
            entry: require('pages/about/entry/about-entry.desktop')
        },
        recipes: {
            list: require('pages/recipes/list/recipes-list.desktop'),
            wall: require('pages/recipes/wall/recipes-wall.desktop'),
            noresult: require('pages/recipes/no-result/recipes-no-result'),
            entry: require('pages/recipes/entry/recipes-entry.desktop')
        },
        news: {
            list: require('pages/news/list/news-list.desktop'),
            entry: require('pages/news/entry/news-entry.desktop')
        },
        videos: {
            list: require('pages/videos/list/videos-list.desktop'),
        },
        products: {
            list: require('pages/products/list/products-list.desktop'),
            entry: require('pages/products/entry/products-entry.desktop')
        },
        contact: {
            index: require('pages/contact/contact-index.desktop')
        },
        master: {
            index: require('pages/master/master-index.desktop')
        },
        unsupported: {
            index: require('pages/browser-not-supported/browser-not-supported-index.desktop')
        },
        error: {
            index: require('pages/error/error-index.desktop')
        },
        sitemap: {
            index: require('pages/sitemap/sitemap-index.desktop')
        }
    }
};

export const map_desktop = map;



// WEBPACK FOOTER //
// ./src/js/map/map.desktop.js